import { Text } from "@react-three/drei";
import React from "react";

interface textObject {
  text: string;
  color: string;
  textRef: any;
}

export const HoverText = ({ text, color, textRef }: textObject) => {
  return (
    <Text
      visible={false}
      ref={textRef}
      font={"/fonts/Orbitron/static/Orbitron-Regular.ttf"}
      fontSize={0.2} // 文字大小
      color={color} // 文字颜色
      anchorX="center" // 水平居中
      anchorY="middle" // 垂直居中
    >
      {text}
    </Text>
  );
};
